var map = {
	"./bg.svg": 1304,
	"./complogo.png": 997,
	"./doc.png": 9171,
	"./file.png": 3641,
	"./logo.png": 6949,
	"./pdf.png": 475,
	"./ppt.png": 5661,
	"./sound.png": 4799,
	"./video.png": 9235,
	"./xls.png": 5376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;